/* eslint-disable ember/no-computed-properties-in-native-classes */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

// Proto: people.Learner.
export default class Learner extends Fragment {
  declare [Type]: 'people/learner';

  @attr()
  declare contacts: unknown;

  @attr('string', { defaultValue: '' })
  declare enrolmentId: string;

  @array()
  declare enrolments: StatefulArray<unknown>;

  @computed('enrolmentId', 'enrolments.@each.enrolmentId')
  get enrolmentStub() {
    return findBy(this.enrolments, 'enrolmentId', this.enrolmentId);
  }

  @attr()
  declare firstSchoolingDate: unknown;

  @attr('string', { defaultValue: '' })
  declare homeroomId: string;

  @attr('string', { defaultValue: '' })
  declare schoolCampusId: string;

  @attr('string', { defaultValue: '' })
  declare schoolId: string;
}
